import { render, staticRenderFns } from "./documentPlayer.vue?vue&type=template&id=624d2373&scoped=true"
import script from "./documentPlayer.vue?vue&type=script&lang=js"
export * from "./documentPlayer.vue?vue&type=script&lang=js"
import style0 from "./documentPlayer.vue?vue&type=style&index=0&id=624d2373&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "624d2373",
  null
  
)

export default component.exports